// @flow
import React from "react"

import type Journey from "common/records/Journey"
import type PassengersCount from "common/records/PassengersCount"
import type { CabinClass } from "common/records/CabinClass"
import JourneyStar from "./JourneyStar"
import JourneyShare from "./JourneyShare"

type Props = {|
  starEnabled: boolean,
  starActive: ?boolean,
  onStarToggle: (Journey, PassengersCount) => void,
  shareEnabled: boolean,
  shareDetached?: boolean,
  shareUrl: string,
  journey: Journey,
  passengers: PassengersCount,
  cabinClass?: CabinClass,
  fixed?: boolean,
|}

const JourneyActionButtons = ({
  starEnabled,
  starActive,
  onStarToggle,
  shareEnabled,
  shareDetached = false,
  shareUrl,
  journey,
  passengers,
  cabinClass,
  fixed,
}: Props) => (
  <div className="JourneyActionButtons" data-test="JourneyActionButtons">
    {starEnabled && (
      <JourneyStar
        active={starActive}
        journey={journey}
        passengers={passengers}
        cabinClass={cabinClass}
        onToggle={onStarToggle}
      />
    )}
    {shareEnabled && (
      <JourneyShare fixed={fixed} detached={shareDetached} journey={journey} url={shareUrl} />
    )}
  </div>
)

export default JourneyActionButtons
